import React, { useState } from 'react';
import NavButton from '../../components/ul/NavButton';

const NavbarLive = ({ selectState }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navItems = [
    {
      to: "/add/liveMatch",
      btnName: "Live Match",
      state: "liveMatch"
    },
    {
      to: "/add/liveMatch/liveAd",
      btnName: "Ads",
      state: "ads",
    },
    {
      to: "/add/liveMatch/liveAdWeb",
      btnName: "Ads Fire",
      state: "adsFire",
    },
    {
      to: "/add/liveMatch/liveAdWeb/history",
      btnName: "Ads History",
      state: "adsHistory"
    }
  ];

  return (
    <nav className="text-main-font w-full p-3 sm:p-4">
      <div className="container">
        {/* Mobile Menu Toggle */}
        <div className="sm:hidden flex justify-end mb-2">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="text-main-font px-2 py-1 border rounded"
          >
            {isMenuOpen ? 'Close' : 'Menu'}
          </button>
        </div>

        {/* Navigation Menu */}
        <ul className={`
          ${isMenuOpen ? 'flex' : 'hidden'} 
          sm:flex 
          flex-col sm:flex-row 
          space-y-2 sm:space-y-0 
          sm:space-x-2 md:space-x-3 lg:space-x-4 
          items-start sm:items-center
        `}>
          {navItems.map((item) => (
            <li
              key={item.state}
              className="w-full sm:w-auto transition-all duration-300 hover:scale-105 active:scale-95"
            >
              <NavButton
                to={item.to}
                btnName={item.btnName}
                selectState={selectState === item.state}
                className="w-full sm:w-auto"
              />
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default NavbarLive;